/** 採購付款金流紀錄（`record_type`／`status`）顯示字。 */
export const PURCHASE_PAYMENT_RECORD_TYPE_LABEL = {
  PAYMENT: '付款',
  REFUND: '退款',
};

export const PURCHASE_PAYMENT_RECORD_STATUS_LABEL = {
  DRAFT: '未確認',
  CONFIRMED: '已確認',
  VOIDED: '已沖銷',
};
